import { fetchLogoImg, createLogoImg } from 'api/customer';
import { attachBase64ImageExtension } from '../../utils/base64Ext';

export const TOGGLE_ACCOUNT_MENU_DROPDOWN = 'TOGGLE_ACCOUNT_MENU_DROPDOWN';
export const SEND_LOGO_SUCCESS = 'SEND_LOGO_SUCCESS';
export const SEND_LOGO_FAIL = 'SEND_LOGO_FAIL';
export const GET_LOGO_SUCCESS = 'GET_LOGO_SUCCESS';
export const GET_LOGO_FAIL = 'GET_LOGO_FAIL';

/**
 * Action to update show/hide AccountMenuDropdown component
 * @param {boolean} value true|false value to show/hide component
 */
export const toggleAccountMenuDropdown = value => dispatch => {
  dispatch({
    type: TOGGLE_ACCOUNT_MENU_DROPDOWN,
    data: value
  });
};

/**
 * Async action creator to fetch base64 logo image. If image is present,
 * attach the image extenstion from logoImgType response key
 */
export const getLogoImg = () => async dispatch => {
  try {
    const dispatchPayload = {
      type: GET_LOGO_SUCCESS
    };
    const logoData = await fetchLogoImg();
    if (logoData.logoImg && logoData.logoImgType) {
      const base64ImageURI = attachBase64ImageExtension(logoData);
      localStorage.setItem('logo', base64ImageURI);
      dispatchPayload.data = base64ImageURI;
    } else {
      localStorage.setItem('logo', '');
      dispatchPayload.data = '';
    }
    dispatch(dispatchPayload);
  } catch (err) {
    dispatch({
      type: GET_LOGO_FAIL,
      err
    });
    throw err;
  }
};

/**
 * Send base64 encoded logo image to backend
 * @param {string} logoImg base64 encoded logo image
 */
export const sendLogoImg = logoImg => async dispatch => {
  try {
    await createLogoImg({ logoImg });
    dispatch({
      type: SEND_LOGO_SUCCESS,
      data: logoImg
    });
  } catch (err) {
    dispatch({
      type: SEND_LOGO_FAIL,
      err
    });
    throw err;
  }
};
